export class ImmutableAPIAccessTrapError extends Error {
  constructor() {
    super('API access traps are immutable');
  }
}
